/**
 * Little's product cards — size pills, click ripple, AJAX add, cart drawer.
 * Event-delegated so cards added later (tabs, rails, editor) work too.
 */
(function () {
  const ATC_SELECTOR = '.ll-product-card__atc';
  const FORM_SELECTOR = '.ll-product-card__form';

  function cartAddUrl() {
    if (window.routes && window.routes.cart_add_url) return window.routes.cart_add_url;
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return `${root}cart/add.js`;
  }

  function cartUi() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  function playRipple(button, event) {
    if (!button || button.disabled) return;
    const rect = button.getBoundingClientRect();
    const size = Math.max(rect.width, rect.height) * 2.2;
    let x = rect.width / 2 - size / 2;
    let y = rect.height / 2 - size / 2;
    if (event && typeof event.clientX === 'number') {
      x = event.clientX - rect.left - size / 2;
      y = event.clientY - rect.top - size / 2;
    }
    const ripple = document.createElement('span');
    ripple.className = 'll-atc-ripple';
    ripple.style.width = `${size}px`;
    ripple.style.height = `${size}px`;
    ripple.style.left = `${x}px`;
    ripple.style.top = `${y}px`;
    button.appendChild(ripple);
    ripple.addEventListener('animationend', () => ripple.remove());
  }

  function setLoading(button, loading) {
    if (!button) return;
    button.classList.toggle('is-loading', loading);
    button.setAttribute('aria-busy', loading ? 'true' : 'false');
    if (loading) {
      button.setAttribute('aria-disabled', 'true');
    } else {
      button.removeAttribute('aria-disabled');
    }
  }

  function syncSize(form, radio) {
    const variantInput = form.querySelector('.ll-product-card__variant-id');
    const atc = form.querySelector(ATC_SELECTOR);
    const label = radio.closest('.ll-product-card__size');
    form.querySelectorAll('.ll-product-card__size').forEach((el) => el.classList.remove('is-selected'));
    if (label) label.classList.add('is-selected');

    const variantId = radio.dataset.variantId;
    if (variantInput && variantId) variantInput.value = variantId;

    const card = form.closest('.ll-product-card');
    const priceEl = card && card.querySelector('.ll-price__current');
    if (priceEl && radio.dataset.price) priceEl.textContent = radio.dataset.price;
    const compareEl = card && card.querySelector('.ll-price__compare');
    if (compareEl) {
      if (radio.dataset.comparePrice) {
        compareEl.textContent = radio.dataset.comparePrice;
        compareEl.removeAttribute('hidden');
      } else {
        compareEl.textContent = '';
        compareEl.setAttribute('hidden', '');
      }
    }

    if (atc) {
      const soldOut = radio.disabled || !variantId;
      atc.disabled = soldOut;
      if (!atc.classList.contains('is-loading')) {
        atc.textContent = soldOut ? 'SOLD OUT' : 'ADD TO CART';
      }
    }
  }

  async function addFromForm(form, button) {
    if (!form || form.dataset.llAdding === 'true') return;
    const atc = button || form.querySelector(ATC_SELECTOR);
    if (!atc || atc.disabled) return;

    const variantInput = form.querySelector('[name="id"]');
    const variantId = variantInput && variantInput.value;
    if (!variantId) return;

    form.dataset.llAdding = 'true';
    setLoading(atc, true);

    const drawer = document.querySelector('cart-drawer');
    const ui = cartUi();
    const formData = new FormData(form);
    [...formData.keys()].forEach((key) => {
      if (key.indexOf('ll-size-') === 0) formData.delete(key);
    });
    if (!formData.get('quantity')) formData.set('quantity', '1');

    if (ui && typeof ui.getSectionsToRender === 'function') {
      formData.append(
        'sections',
        ui.getSectionsToRender().map((section) => section.id).join(',')
      );
      formData.append('sections_url', window.location.pathname);
      if (typeof ui.setActiveElement === 'function') ui.setActiveElement(atc);
    } else {
      formData.append('sections', 'cart-drawer,cart-icon-bubble');
      formData.append('sections_url', window.location.pathname);
    }

    try {
      const response = await fetch(cartAddUrl(), {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
      });
      const data = await response.json();

      if (!response.ok || data.status) {
        throw new Error(data.description || data.message || 'Unable to add to cart.');
      }

      if (drawer) {
        drawer.classList.remove('is-empty');
        drawer.querySelector('cart-drawer-items')?.classList.remove('is-empty');
      }

      if (ui && typeof ui.renderContents === 'function' && data.sections) {
        ui.renderContents(data);
      } else if (drawer && typeof drawer.open === 'function') {
        drawer.open(atc);
      } else if (window.routes && window.routes.cart_url) {
        window.location.href = window.routes.cart_url;
        return;
      }

      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          detail: { source: 'll-product-card', variantId, data },
        })
      );
    } catch (err) {
      console.error(err);
      atc.disabled = false;
    } finally {
      form.dataset.llAdding = 'false';
      setLoading(atc, false);
      if (!atc.disabled) atc.textContent = 'ADD TO CART';
    }
  }

  document.addEventListener(
    'pointerdown',
    (event) => {
      const button = event.target.closest(ATC_SELECTOR);
      if (!button || button.disabled) return;
      playRipple(button, event);
    },
    true
  );

  document.addEventListener('change', (event) => {
    const radio = event.target.closest('.ll-product-card__size input[type="radio"]');
    if (!radio) return;
    const form = radio.closest(FORM_SELECTOR);
    if (form) syncSize(form, radio);
  });

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target.closest(FORM_SELECTOR);
      if (!form) return;
      event.preventDefault();
      event.stopPropagation();
      const atc = form.querySelector(ATC_SELECTOR);
      if (atc && !atc.querySelector('.ll-atc-ripple')) playRipple(atc);
      addFromForm(form, atc);
    },
    true
  );
})();
